/*
  Reviews: partial star, heading widow, and the five-star-first curation.

  Moved out of sections/brewzle-reviews.liquid on 2026-09-21. It was inline, so it ran during
  parse and held up first paint: Lighthouse put 1,841ms of main thread on the
  document itself, and the hero photo, already downloaded by ~480ms, was waiting
  on it. Loaded with defer instead, which runs after the document is parsed.

  The code is unchanged apart from the root lookup. It used to interpolate the
  section id into a class selector; it now finds the same element by the
  data-bz-section attribute the section already carries.
*/
(function () {
      // Scoped per instance, the way the inline version was: it keyed on its own
      // section id, so a second copy of this section on a page got its own
      // behaviour. A bare querySelector would have bound only the first. One
      // instance per page on templates/page.brewzle.json today; this does not
      // rely on that staying true.
      var bzRoots = document.querySelectorAll('[data-bz-section="reviews"]');
      for (var bzIndex = 0; bzIndex < bzRoots.length; bzIndex++) initBrewzleReviews(bzRoots[bzIndex]);

      function initBrewzleReviews(root) {

      function applyPartialStar() {
        var box = root.querySelector('.jdgm-rev-widg__summary-stars');
        if (!box) return false;
        var label = box.getAttribute('aria-label') || '';
        var match = label.match(/([\d.]+)/);
        if (!match) return true;
        var fraction = parseFloat(match[1]) % 1;
        if (fraction <= 0) return true;
        var half = box.querySelector('.jdgm-star.jdgm--half');
        if (half) half.style.setProperty('--bz-star-frac', (fraction * 100).toFixed(1) + '%');
        return true;
      }

      function glueHeadingOrphan() {
        var heading = root.querySelector('.pdp-jdgm__heading');
        if (!heading) return false;
        if (heading.dataset.bzPretty) return true;
        var words = (heading.textContent || '').trim().split(/\s+/);
        if (words.length >= 2) {
          heading.textContent = words.slice(0, -2).concat(words.slice(-2).join('\u00A0')).join(' ');
        }
        heading.dataset.bzPretty = '1';
        return true;
      }

      function apply() {
        return applyPartialStar() && glueHeadingOrphan();
      }

      // Harpawan and Harjot, 2026-09-17 call: the detailed reviews lead, the ones
      // with photos first, and one-star to three-star reviews go to the end.
      // Judge.me's widget sorts "pictures first" (any rating) five at a time,
      // so a one-star photo review could open the list. Two things fix that:
      // the first three pages are loaded up front so there is a pool to rank,
      // and after every render the list is re-ordered by quality: five-star
      // with a photo and a real write-up, then five-star write-ups, then the
      // short five-star ones, then four-star, then everything else. Nothing is
      // hidden. The PDP's widget is untouched; this runs inside the section.
      var LONG_BODY = 60;
      function ratingOf(rev) {
        var r = rev.querySelector('.jdgm-rev__rating');
        var score = r ? Number(r.getAttribute('data-score')) : NaN;
        if (!isFinite(score)) {
          score = rev.querySelectorAll('.jdgm-rev__rating .jdgm-star.jdgm--on').length;
        }
        return score;
      }
      function tierOf(stars, pics, length) {
        if (stars >= 5 && pics > 0 && length >= LONG_BODY) return 0;
        if (stars >= 5 && length >= LONG_BODY) return 1;
        if (stars >= 5 && pics > 0) return 2;
        if (stars >= 5) return 3;
        if (stars >= 4) return 4;
        return 5;
      }
      // Judge.me's Load more is an <a> with no href. theme.js's external-link
      // handler runs `new URL(link.href)` on every anchor click, so each Load
      // more click (a shopper's or the preload below) logged "Invalid URL". Give
      // the link a same-page href (same hostname, so theme.js leaves it alone)
      // and cancel the anchor's own navigation; Judge.me's delegated handler
      // reads data-page, not href, so paging is unchanged. Re-applied after
      // every render because Judge.me rewrites the link.
      function tameLoadMore() {
        var more = root.querySelector('.jdgm-paginate__load-more');
        if (!more) return;
        if (!more.getAttribute('href')) more.setAttribute('href', window.location.pathname + window.location.search);
        if (!more.dataset.bzTamed) {
          more.dataset.bzTamed = '1';
          more.addEventListener('click', function (e) { e.preventDefault(); });
        }
      }
      // data-bz-photos-min on the section root (the BOF page sets 4, Harpawan 2026-10-01: its
      // first photo opened a two-star complaint) keeps only customer photos whose review is
      // rated that or higher. Judge.me builds the photo row from the loaded reviews, so each
      // photo's review is in the list; a photo whose review is not there stays hidden too.
      var PHOTOS_MIN = Number(root.getAttribute('data-bz-photos-min')) || 0;
      function filterGallery() {
        if (!PHOTOS_MIN) return;
        var scores = {};
        root.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (rev) {
          scores[rev.getAttribute('data-review-id')] = ratingOf(rev);
        });
        root.querySelectorAll('.jdgm-gallery__thumbnail-link').forEach(function (link) {
          var img = link.querySelector('[data-review-id]');
          var score = img ? scores[img.getAttribute('data-review-id')] : NaN;
          var keep = isFinite(score) && score >= PHOTOS_MIN;
          if (link.hidden === !keep) return;
          link.hidden = !keep;
          link.style.display = keep ? '' : 'none';
        });
        // No photo qualifies: the "Customer photos" heading would sit over an empty row.
        root.querySelectorAll('.jdgm-gallery-wrapper').forEach(function (wrap) {
          var any = wrap.querySelector('.jdgm-gallery__thumbnail-link:not([hidden])');
          wrap.style.display = any ? '' : 'none';
        });
      }
      // data-bz-static-histogram (the BOF page, Harpawan 2026-10-01): a tap on a star bar made
      // Judge.me filter the list to that rating, the list changed height under the finger and
      // the page jumped about 790px, into reviews this ranking hides anyway. The bars stay as
      // a summary: the tap is stopped before Judge.me sees it and the rows leave the tab order.
      if (root.hasAttribute('data-bz-static-histogram')) {
        root.addEventListener('click', function (e) {
          var row = e.target.closest && e.target.closest('.jdgm-histogram__row');
          if (!row) return;
          e.preventDefault();
          e.stopPropagation();
        }, true);
        root.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.jdgm-histogram__row')) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
      function staticHistogram() {
        if (!root.hasAttribute('data-bz-static-histogram')) return;
        // Judge.me puts role="button" and tabindex="0" on each bar's star group; its label
        // ("78% (1116) reviews with 5 star rating") stays as the summary it is.
        root.querySelectorAll('.jdgm-histogram__row, .jdgm-histogram__row [role="button"], .jdgm-histogram__row [tabindex]').forEach(function (el) {
          if (el.getAttribute('tabindex') !== null) el.removeAttribute('tabindex');
          if (el.getAttribute('role') === 'button') el.setAttribute('role', el.hasAttribute('aria-label') ? 'img' : 'presentation');
        });
      }
      function curateReviews() {
        filterGallery();
        staticHistogram();
        tameLoadMore();
        var list = root.querySelector('.jdgm-rev-widg__reviews');
        if (!list) return false;
        var revs = Array.prototype.slice.call(list.querySelectorAll('.jdgm-rev'));
        if (!revs.length) return false;
        var scored = revs.map(function (rev, index) {
          var body = ((rev.querySelector('.jdgm-rev__body') || {}).textContent || '').trim();
          var pics = rev.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-img, .jdgm-rev__pics img, .jdgm-rev__pic-link').length;
          var stars = ratingOf(rev);
          var tier = tierOf(stars, pics, body.length);
          rev.setAttribute('data-bz-tier', String(tier));
          return { rev: rev, index: index, pics: pics, stars: stars, length: body.length, tier: tier };
        });
        scored.sort(function (a, b) {
          if (a.tier !== b.tier) return a.tier - b.tier;
          if (a.stars !== b.stars) return b.stars - a.stars;
          if ((a.pics > 0) !== (b.pics > 0)) return a.pics > 0 ? -1 : 1;
          if (a.length !== b.length) return b.length - a.length;
          return a.index - b.index;
        });
        // Move nodes only when the order is actually different: every
        // appendChild is a mutation, and the observer below would otherwise
        // answer our own reorder with another reorder, forever (the 2026-09-18
        // page that never reached `load` and posted analytics in a loop).
        // A Judge.me page that just arrived after a See more click counts as
        // that click's reveal.
        if (revealOnLoad && scored.length > lastTotal) { visibleCount += VISIBLE_STEP; revealOnLoad = false; }
        lastTotal = scored.length;
        var changed = false;
        var shown = 0;
        scored.forEach(function (item, i) {
          if (item.rev !== revs[i]) changed = true;
          // Only the top of the ranking shows; the rest wait behind See more
          // (Harjot, 2026-09-18: four or five on the page, not the whole pool).
          // One to three stars never show while Judge.me still has pages to
          // fetch: they are the tail of the whole catalogue, not of this pool.
          var hide = shown >= visibleCount || (item.tier === LOW_TIER && !showLow);
          if (!hide) shown += 1;
          if (item.rev.hidden !== hide) item.rev.hidden = hide;
        });
        if (changed) {
          reordering = true;
          scored.forEach(function (item) { list.appendChild(item.rev); });
          observer.takeRecords();
          reordering = false;
        }
        ownMoreButton();
        // Fewer than four four-and-five-star reviews on the page (a first
        // Judge.me page heavy with low ratings): fetch the next page at once
        // rather than waiting for the load-time preload.
        if (shown < MIN_VISIBLE) topUp();
        return true;
      }
      // data-bz-visible on the section root sets how many show per step (the BOF page
      // shows 3, its frame's count); the top-up floor never exceeds it, or a page
      // showing 3 would read as short of reviews and fetch every page.
      var VISIBLE_SETTING = Number(root.getAttribute('data-bz-visible')) || 5;
      var MIN_VISIBLE = Math.min(4, VISIBLE_SETTING);
      var lastTopUp = 0;
      function topUp() {
        if (!near) { pendingTopUp = true; return; }
        var more = root.querySelector('.jdgm-paginate__load-more:not([data-bz-more])');
        if (!more || more.offsetParent === null) return;
        var now = Date.now();
        if (now - lastTopUp < 1500) return;
        lastTopUp = now;
        tameLoadMore();
        preloading = true;
        more.click();
        preloading = false;
      }
      var reordering = false;
      var VISIBLE_STEP = VISIBLE_SETTING;
      var LOW_TIER = 5;
      var visibleCount = VISIBLE_STEP;
      var preloading = false;
      var showLow = false;
      var revealOnLoad = false;
      var lastTotal = 0;
      function hiddenGoodCount() {
        return root.querySelectorAll('.jdgm-rev[hidden]:not([data-bz-tier="' + LOW_TIER + '"])').length;
      }
      function hiddenCount() {
        return root.querySelectorAll('.jdgm-rev[hidden]').length;
      }
      // Judge.me drops its Load more on the last page. If ranked reviews are
      // still hidden at that point (the one to three star tail), a button of
      // our own, styled like Judge.me's, reveals them.
      function ownMoreButton() {
        var jm = root.querySelector('.jdgm-paginate__load-more');
        var own = root.querySelector('[data-bz-more]');
        var hiddenAny = hiddenCount() > 0;
        if (!jm && hiddenAny && !own) {
          var paginate = root.querySelector('.jdgm-paginate') || root.querySelector('.jdgm-rev-widg__reviews');
          if (!paginate) return;
          own = document.createElement('a');
          own.className = 'jdgm-btn jdgm-btn--solid jdgm-paginate__load-more';
          own.setAttribute('href', window.location.pathname + window.location.search);
          own.setAttribute('data-bz-more', '1');
          own.textContent = 'See more';
          if (paginate.classList.contains('jdgm-paginate')) paginate.appendChild(own);
          else paginate.parentNode.insertBefore(own, paginate.nextSibling);
        } else if (own && (!hiddenAny || jm)) {
          own.remove();
        }
      }
      // See more reveals the next five ranked four and five star reviews. When
      // those run out the click reaches Judge.me for another page, and that
      // page's arrivals are revealed. Only when Judge.me has no page left do the
      // one to three star reviews come out, five at a time.
      root.addEventListener('click', function (e) {
        var more = e.target.closest && e.target.closest('.jdgm-paginate__load-more');
        if (!more || preloading) return;
        if (more.hasAttribute('data-bz-more')) {
          e.preventDefault();
          e.stopPropagation();
          showLow = true;
          visibleCount += VISIBLE_STEP;
          curateReviews();
          return;
        }
        if (hiddenGoodCount() > 0) {
          e.preventDefault();
          e.stopPropagation();
          visibleCount += VISIBLE_STEP;
          curateReviews();
          return;
        }
        revealOnLoad = true;
      }, true);
      var curating = false;
      function curateSoon() {
        if (curating) return;
        curating = true;
        setTimeout(function () {
          curating = false;
          curateReviews();
        }, 30);
      }
      // Click Judge.me's own Load more (five reviews a page, "pictures first")
      // until 25 reviews are in, so the ranking picks the opening ones from a
      // real pool of photo reviews instead of the first five. Runs on its own
      // clock, not on the mutation observer, so a slow fetch cannot stall it.
      var TARGET_REVIEWS = 25;
      var MAX_CLICKS = 5;
      var clicks = 0;
      function preloadMore() {
        if (clicks >= MAX_CLICKS) return;
        if (root.querySelectorAll('.jdgm-rev').length >= TARGET_REVIEWS) return;
        var more = root.querySelector('.jdgm-paginate__load-more');
        if (!more || more.offsetParent === null) { setTimeout(preloadMore, 700); return; }
        tameLoadMore();
        clicks += 1;
        preloading = true;
        more.click();
        preloading = false;
        setTimeout(preloadMore, 1800);
      }
      // Start after the window's load event: reviews appended before it carry
      // photos the load event then waits for (the 2026-09-18 twenty-second
      // spinner). And only once the section is within 1500px of the viewport
      // (2026-09-21): each extra page is a Judge.me fetch, a parse and a layout,
      // and this section sits about 7000px down a phone. Run at load, those four
      // fetches were the largest item in the page's Speed Index (Lighthouse's
      // simulation put their layouts at 42s), for reviews nobody had scrolled
      // to yet. A shopper scrolling down reaches the margin with a screen and a
      // half to spare; without IntersectionObserver the old load-time start
      // stands.
      var near = false;
      var pendingTopUp = false;
      function onNear() {
        if (near) return;
        near = true;
        setTimeout(preloadMore, 200);
        if (pendingTopUp) { pendingTopUp = false; topUp(); }
      }
      function watchNear() {
        if (!('IntersectionObserver' in window)) { setTimeout(onNear, 800); return; }
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { io.disconnect(); onNear(); return; }
          }
        }, { rootMargin: '1500px 0px' });
        io.observe(root);
      }
      if (document.readyState === 'complete') watchNear();
      else window.addEventListener('load', watchNear, { once: true });
      var observer = new MutationObserver(function (mutations) {
        if (reordering) return;
        for (var i = 0; i < mutations.length; i++) {
          var target = mutations[i].target;
          if (target && target.closest && (target.closest('.jdgm-rev-widg__reviews') || target.closest('.jdgm-gallery'))) { curateSoon(); return; }
        }
      });
      observer.observe(root, { childList: true, subtree: true });

      if (apply()) { curateReviews(); return; }
      var ticks = 0;
      var timer = setInterval(function () {
        if (apply() || ++ticks > 100) { clearInterval(timer); curateReviews(); }
      }, 50);
      }
    })();
